var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper-app wrapper-app__full"},[_c('router-view'),_c('pounds-translator'),_c('audio-button'),(_vm.isLogged())?_c('feedback-button'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }